/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Formvalidation_Invalid1Inputs */

const en_formvalidation_invalid1 = /** @type {(inputs: Formvalidation_Invalid1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is not valid`)
};

/**
* | output |
* | --- |
* | "{name} is not valid" |
*
* @param {Formvalidation_Invalid1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_invalid1 = /** @type {((inputs: Formvalidation_Invalid1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Invalid1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_invalid1(inputs)
});
export { formvalidation_invalid1 as "formValidation_invalid" }